import React, { useState, useEffect, useRef, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePlayerProgress } from '../contexts/PlayerContext';
import { motion, AnimatePresence } from 'framer-motion';

const XPToast = () => {
  const { t } = useTranslation();
  const { lastXpGain } = usePlayerProgress();
  const [toasts, setToasts] = useState([]);
  const accumulatorRef = useRef({ amount: 0, timer: null });

  useEffect(() => {
    if (!lastXpGain || !lastXpGain.amount) return;

    const acc = accumulatorRef.current;
    acc.amount += lastXpGain.amount;

    if (acc.timer) clearTimeout(acc.timer);
    acc.timer = setTimeout(() => {
      const id = Date.now();
      const amount = acc.amount;
      acc.amount = 0;
      acc.timer = null;

      setToasts(prev => [...prev, { id, amount }]);

      // Auto-dismiss after 2s
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, 2000);
    }, 500);
  }, [lastXpGain]);

  return (
    <div style={{
      position: 'fixed',
      top: 105,
      right: 20,
      zIndex: 1000,
      pointerEvents: 'none',
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
    }}>
      <AnimatePresence>
        {toasts.map(toast => (
          <motion.div
            key={toast.id}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            style={{
              color: '#4caf50',
              fontSize: 14,
              fontWeight: 700,
              textShadow: '0 1px 4px rgba(0,0,0,0.5)',
            }}
          >
            {t('xp_gain', { amount: toast.amount })}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default memo(XPToast);
